<template>
  <v-layout column mx-auto>
    <v-flex mt-6>
      <v-img src="../assets/logo.png" height="100" contain></v-img>
    </v-flex>
    <v-flex mt-6>
      <v-card dark class="mx-auto" max-width="800" color="rgb(18,18,18,0.5)">
        <v-toolbar flat color="transparent">
          <v-toolbar-title>Create Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn to="login" color="secondary darken-2">Log in</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
            @submit.prevent="createAccount"
          >
            <v-text-field
              outlined
              v-model="account.firstname"
              :rules="[rules.required]"
              label="First Name"
              required
            ></v-text-field>
            <v-text-field
              outlined
              v-model="account.lastname"
              :rules="[rules.required]"
              label="Last Name"
              required
            ></v-text-field>
            <v-text-field
              outlined
              v-model="account.emailAddress"
              :rules="[rules.required, rules.emailAddress]"
              label="Email Address"
              required
            ></v-text-field>
            <v-autocomplete
              v-model="account.role"
              :rules="[rules.required]"
              label="Role"
              :items="roles"
              item-text="name"
              item-value="value"
              required
            ></v-autocomplete>

            <v-autocomplete
              v-model="account.companyId"
              :rules="[v => !!v || 'Company is required']"
              label="Company"
              :items="companies"
              item-text="name"
              item-value="companyId"
              required
            ></v-autocomplete>

            <v-text-field
              v-model="account.newPassword"
              :rules="[v => !!v || 'Password is required']"
              label="Password"
              type="password"
              required
            ></v-text-field>
            <v-text-field
              v-model="account.confirmNewPassword"
              :rules="[
                v => !!v || 'Password confirmation is required',
                v =>
                  v === this.account.newPassword || 'New passwords must match'
              ]"
              label="Confirm Password"
              type="password"
              required
            ></v-text-field>

            <v-btn
              class="mt-4"
              type="submit"
              color="primary darken-2"
              dark
              :loading="loading"
              >Create Account</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import UserService from "@/services/UserService";
import CompanyService from "@/services/CompanyService";
export default {
  data() {
    return {
      formValid: true,
      account: {
        firstname: "",
        lastname: "",
        emailAddress: "",
        companyId: "",
        role: "",
        newPassword: "",
        confirmNewPassword: ""
      },
      freshAccount: {},
      rules: {
        required: value => !!value || "Field Required.",
        emailAddress: v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      },
      loading: false,
      roles: [
        { name: "Visitor", value: "VIS" },
        { name: "Contractor", value: "CON" },
        { name: "Employee", value: "EMP" }
      ],
      companies: []
    };
  },
  created() {
    this.getCompanies();
  },

  methods: {
    createAccount() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const newAccount = {
          companyId: this.account.companyId,
          firstname: this.account.firstname,
          lastname: this.account.lastname,
          role: this.account.role,
          emailAddress: this.account.emailAddress,
          password: this.account.newPassword
        };
        UserService.postUserSignUp(newAccount)
          .then(response => {
            this.freshAccount = response.data;
            this.$snackbarSuccess("Account Created");
            this.loading = false;
            this.$router.push({ name: "login" });
          })
          .catch(e => {
            this.$snackbarError(e.response.data);
            this.loading = false;
          });
      }
    },
    getCompanies() {
      CompanyService.getCompanies().then(response => {
        this.companies = response;
      });
    }
  }
};
</script>
